export type AssetMake = {
    id: number
    name: string
    description: string
}

export function newAssetMake(): AssetMake {
    return {
        id: 0,
        name: "",
        description: "",
    }
}
